var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypage-about-using-section"},[_c('about-using-data-list-parts',{attrs:{"aboutUsingListItems":_vm.aboutUsingListItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }